/**
 * Shared sizing for the fields (inputs, selects, autocompletes) rendered inside
 * table toolbars. Toolbar fields always use the medium design system variant,
 * stay fluid, and are separated by `TOOLBAR_FIELD_GAP`.
 */
export const TOOLBAR_FIELD_GAP = '8px';

export const TOOLBAR_FIELD_MIN_WIDTH = '140px';
export const TOOLBAR_FIELD_MAX_WIDTH = '320px';

export const toolbarFieldSx = {
  flex: 1,
  minWidth: TOOLBAR_FIELD_MIN_WIDTH,
  maxWidth: TOOLBAR_FIELD_MAX_WIDTH,
};
